import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Row, Col, Input, Radio } from 'antd';
import Navigation from '../public/navigation';
import CSBrowser from '../public/cs-browser';

const store = ['modeListStore', 'homeStore', 'listStore']
const RadioGroup = Radio.Group;
@inject(...store)
@observer
class App extends React.Component {

  static defaultProps = {
    prefixCls: 'order-list',
  }
  constructor(props) {
    super(props);
    this.state = {
      width: 1340,
      col: 6,
    }
  }
  componentDidMount() {
    const {
      modeListStore: { buyV2 },
    } = this.props;
    buyV2();
  }

  getNavs = () => {
    const { location: { query: { id } } } = this.props;
    const navs = [
      { key: '1', breadcrumbName: '云商店', path: '/' },
      { key: '2', breadcrumbName: id === 'mode' ? '建模应用' : id === 'dev' ? '定制开发' : '非标应用', path: '/' },
      { key: '3', breadcrumbName: '我的订单', },
    ];
    return navs;
  }
  render() {
    let { prefixCls, location: { query }, homeStore: { setType }, modeListStore: { routing, orderServerList } } = this.props;
    const isSearch = window.location.hash.indexOf('app/search') >= 0;
    return (
      <div ref={c => this.modeList = c} className='home-page-mode-list' style={isSearch ? { paddingTop: 0 } : {}}>
        <Navigation datas={this.getNavs()} onClick={(obj) => {
          if (obj.key === '1') {
            setType('all', '全部应用');
            routing.push('/');
          }
          else routing.push({
            pathname: obj.path,
            query,
          })
        }} />
        <div className={prefixCls}>
          <div className={`${prefixCls}-header`}>
            <Row className={`${prefixCls}-header-row`}>
              <Col span={2} className={`${prefixCls}-header-label`}>服务器：</Col>
              <Col span={6}>
                <CSBrowser datas={toJS(orderServerList)} />
              </Col>
              <Col span={2} className={`${prefixCls}-header-label`}>应用名称：</Col>
              <Col span={6}>
                <Input />
              </Col>
            </Row>
            <Row className={`${prefixCls}-header-row`}>
              <Col span={2} className={`${prefixCls}-header-label`}>申请类型：</Col>
              <Col span={6}>
                <RadioGroup>
                  <Radio value="all">全部</Radio>
                  <Radio value="1">试用</Radio>
                  <Radio value="2">永久</Radio>
                </RadioGroup>
              </Col>
              <Col span={2} className={`${prefixCls}-header-label`}>版本：</Col>
              <Col span={6}>
                <RadioGroup>
                  <Radio value="all">全部</Radio>
                  <Radio value="1">alpha</Radio>
                  <Radio value="2">beta</Radio>
                </RadioGroup>
              </Col>
              <Col span={2} className={`${prefixCls}-header-label`}>订单状态：</Col>
              <Col span={6}>
                <RadioGroup>
                  <Radio value="all">全部</Radio>
                  <Radio value="1">通过</Radio>
                  <Radio value="2">驳回</Radio>
                  <Radio value="2">申请</Radio>
                </RadioGroup>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/OrderList.js